<script setup lang="js">

  const currentYear = new Date().getFullYear();

  import { ref, onMounted, onBeforeUnmount } from 'vue';
  import SvgLogo from './Elements/SvgLogo.vue'
  import navConfig from '../../src/assets/navConfig.json'
  // Variables
  const isMobile = ref(window.innerWidth <= 768);

  // Functions
  function handleResize() {
    isMobile.value = window.innerWidth <= 768;
    setInitialAccordionState();
  }

  function setInitialAccordionState() {
    const accordionElements = document.querySelectorAll('.accordion-button[aria-expanded="false"]');
    if (accordionElements) {
      accordionElements.forEach(el => {
          el.classList.add('collapsed');
        });
    }
  }

  onMounted(() => {
    window.addEventListener('resize', handleResize);
    setInitialAccordionState();
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize);
  });
</script>

<template>
  <template v-if="!isMobile">
    <div id="footer">
      <div class="footer-top">
        <div class="footer-logo">
          <SvgLogo width="200" height="200" />
        </div>
        <div class="footer-links">
          <ul class="navbar-items-group">
            <li v-for="(group, groupIndex) in navConfig" :key="groupIndex" class="navbar-block">
              <ul>
                <li class="nav-item top-item">
                  <RouterLink :to="group.link" class="nav-link">
                    {{ group.name }}
                  </RouterLink>
                </li>
                <template v-for="(item, itemIndex) in group.submenu" :key="itemIndex">
                  <li v-if="item.type === 'link'" class="nav-item">
                    <RouterLink
                      class="nav-link"
                      :to="item.path ? { path: item.path } : { path: group.link, hash: item.hash }"
                    >
                      {{ item.title }}
                    </RouterLink>
                  </li>
                </template>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer-bot">
        <div class="legals-block">
          <nav>
            <div class="navbar">
              <ul class="navbar-legal-items-group">
                <li class="nav-item">&#169; {{ currentYear }}. Gede-Tech GmbH.</li>
                <li class="nav-item">
                  <RouterLink to="/impressum" class="nav-link">Impressum</RouterLink>
                </li>
                <li class="nav-item">
                  <RouterLink to="/datenschutz" class="nav-link">Datenschutz</RouterLink>
                </li>
                <li class="nav-item">
                  <RouterLink to="/agb" class="nav-link">AGB´s</RouterLink>
                </li>
              </ul>
            </div>
          </nav>
        </div>        
      </div>
    </div>
  </template>
  <template v-if="isMobile">
    <div id="footer">
      <div class="footer-top">
        <div class="footer-logo">
          <SvgLogo width="200" height="200" />
        </div>
      
        <div class="footer-links">
          <div class="accordion" id="footerAccordion">
            <div class="navbar-items-group">
              <div
                v-for="(group, groupIndex) in navConfig"
                :key="groupIndex"
                class="accordion-item"
              >
                <!-- Accordion Header -->
                <h2 class="accordion-top" :id="'heading' + groupIndex">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    :data-bs-target="'#collapse' + groupIndex"
                    aria-expanded="false"
                    :aria-controls="'collapse' + groupIndex"
                  >
                    {{ group.name }}
                  </button>
                </h2>

                <!-- Accordion Body -->
                <div
                  :id="'collapse' + groupIndex"
                  class="accordion-collapse collapse"
                  :aria-labelledby="'heading' + groupIndex"
                  data-bs-parent="#footerAccordion"
                >
                  <div class="accordion-body">
                    <ul>                     
                      <!-- Submenu Items -->
                      <template v-for="(item, itemIndex) in group.submenu" :key="itemIndex">
                        <li v-if="item.type === 'link'" class="nav-item">
                          <RouterLink
                            class="nav-link"
                            :to="
                              item.path
                                ? { path: item.path }
                                : { path: group.link, hash: item.hash }
                            "
                          >
                            {{ item.title }}
                          </RouterLink>
                        </li>                      
                      </template>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bot">
        <div class="legals-block">
          <nav>
            <div class="navbar">
              <ul class="navbar-legal-items-group">
                <li class="nav-item">
                  <RouterLink to="/impressum" class="nav-link">Impressum</RouterLink>
                </li>
                <li class="nav-item">
                  <RouterLink to="/datenschutz" class="nav-link">Datenschutz</RouterLink>
                </li>
                <li class="nav-item">
                  <RouterLink to="/agb" class="nav-link">AGB´s</RouterLink>
                </li>
              </ul>
            </div>
          </nav>
        </div>        
        <div class="legals-block">
          <nav>
            <div class="navbar">
              <div class="navbar-legal-items-group">
                <div class="nav-item">
                  <span class="nav-link">&#169; {{ currentYear }}. Gede-Tech GmbH.</span>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </template>
</template>

<style scoped lang="scss">
  @import '@/scss/variables.scss';

  #footer {
    background-color: $brand-primary-color;

    .footer-top {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      padding-top: 20px;

      @include mobile {
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .footer-logo {
        // padding: 20px 10px 5px;
        display: flex;
        align-items: center;

        @include mobile {
          padding: 40px 10px 20px;
        }
      }

      .footer-links {
        display: flex;
        align-items: center;

        ul {
          display: flex;
          flex-direction: row;
          align-items: left;
          padding: 0;

          .navbar-block {
            padding: 0 20px;
            list-style-type: none;

            ul {
              flex-direction: column;
            }

            .nav-item {
              text-align: left;
              margin-bottom: 10px;
              list-style: none;
              font-size: 0.875rem;

              &.top-item {
                margin-bottom: 20px;
                font-size: 1.125rem;
              }
            }
          }

          .nav-link {
            display: inline;

            color: $brand-white;
            text-align: left;
            margin-bottom: 10px;
            background-image: linear-gradient(to top, $brand-secondary-color 1px, transparent 1px);
            background-repeat: no-repeat, no-repeat;
            background-position-x: left;
            background-size: 0 100%, 100% 100%;
            padding-bottom: 2px;
            transition: background-size 0.42s cubic-bezier(0.165, 0.84, 0.44, 1);
            background-origin: right;

            &:hover,
            &:focus {
              color: $brand-secondary-color;
              background-size: 100% 100%, 100% 100%;
            }
          }
        }
      }

      @include mobile {
        padding-top: 0;

        .footer-links {
          width: 100%;

          .accordion {
            width: 100%;

            .accordion-item {
              border: unset;

              &:first-child {
                .accordion-top {
                  .accordion-button {
                    border-top: 1px solid $brand-white;
                  }
                }
              }

              .accordion-body {
                border-bottom: 1px solid $brand-white;

                .nav-item {
                  list-style-type: none;
                  text-align: left;

                  .nav-link {
                    margin: 10px 0;
                  }
                }
              }

              .accordion-top {
                margin-bottom: 0;

                .accordion-button {
                  border-bottom: 1px solid $brand-white;
                  background-color: $brand-primary-color; // Dieser Code wird angewendet, wenn der Bildschirm mindestens 600px breit ist.
                  color: $brand-white;

                  &:focus {
                    box-shadow: none;
                  }

                  &:after {
                    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
                  }
                }
              }

              .accordion-body {
                background-color: $brand-background-color-1;
                padding-left: 40px;

                .nav-item {
                  margin: 10px 0;

                  a {
                    &:hover,
                    &:focus {
                      color: $brand-white;
                      text-decoration: none;
                      background: unset;
                    }
                  }
                }

                ul {
                  display: flex;
                  flex-direction: column;
                  background-color: $brand-background-color-1;
                  margin: 0;
                }
              }
            }
          }
        }
      }
    }

    .footer-bot {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 30px 40px;
      border-top: 1px solid $brand-divider-color;
      height: 100px;
      width: 100%;
      align-items: center;

      .legals-block {
        height: 100%;

        * {
          height: 100%;
        }

        .navbar {
          padding: 0;

          .navbar-legal-items-group {
            display: flex;
            flex-direction: row;
            padding: 0;
            margin: 0;

            .nav-item {
              list-style-type: none;
              display: flex;
              align-items: center;

              &:first-of-type {
                color: $brand-white;
                margin-right: 20px;
              }

              .nav-link:first-of-type {
                color: $brand-white;
                list-style: none;
                margin-right: 20px;
              }

              .nav-link {
                list-style: none;
                margin-right: 20px;
                color: $brand-white;
                align-items: center;
                display: flex;
                background-image: linear-gradient(
                  to top,
                  $brand-secondary-color 1px,
                  transparent 1px
                );
                background-repeat: no-repeat, no-repeat;
                background-position-x: left;
                background-size: 0 100%, 100% 100%;
                padding-bottom: 2px;
                transition: background-size 0.42s cubic-bezier(0.165, 0.84, 0.44, 1);

                &:hover,
                &:focus {
                  color: $brand-secondary-color;
                  background-size: 100% 100%, 100% 100%;
                }
              }
            }
          }
        }
      }

      .socials-block {
        display: flex;
        align-items: center;
        height: 100%;

        .socials-block-icons {
          display: flex;
          flex-direction: row;
          padding: 0;
          margin: 0;
          height: 100%;

          .social-icon {
            list-style: none;
            padding-right: 20px;
            height: 100%;
            display: flex;
            align-items: center;

            .fa.fa-linkedin {
              text-decoration: none;

              &::before {
                background-color: $brand-white;
                color: $brand-primary-color;
                padding: 10px;
                border-radius: 4px;
              }

              &:hover::before {
                background-color: $brand-secondary-color;
                // color: $brand-white;
              }
            }
          }
        }
      }

      @include mobile {
        flex-direction: column;
        justify-content: center;
        height: auto;

        .socials-block {
          height: 36px;
          margin: 30px 0;

          .socials-block-icons .social-icon:last-of-type {
            padding: 0;
          }
        }

        .legals-block {
          .navbar {
            justify-content: center;
            display: flex;

            .navbar-legal-items-group {
              flex-direction: column;
              align-items: center;

              .nav-item {
                &:first-of-type {
                  margin-right: 0;
                }

                margin: 10px 0;

                .nav-link {
                  &:first-of-type {
                    margin-right: 0;
                  }

                  &:hover,
                  &:focus {
                    color: $brand-white;
                    text-decoration: none;
                    background: unset;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>
